"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SyncLogs;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SyncLogs = class SyncLogs {
    static async list(context, baseId, ncMeta = _Noco.default.ncMeta) {
        const syncLogs = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.SYNC_LOGS, {
            condition: {
                base_id: baseId
            },
            orderBy: {
                created_at: 'asc'
            }
        });
        return syncLogs == null ? void 0 : syncLogs.map((h)=>new SyncLogs(h));
    }
    static async insert(context, syncLog, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(syncLog, [
            'base_id',
            'fk_sync_source_id',
            'time_taken',
            'status',
            'status_details'
        ]);
        const { id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.SYNC_LOGS, insertObj);
        return new SyncLogs(_extends({}, insertObj, {
            id
        }));
    }
    constructor(syncLog){
        Object.assign(this, syncLog);
    }
};
